import { useEffect, useRef } from "react";

const DEBOUNCE_DELAY = 500;

const useAnnounceFilterResults = (rowCount: number, searchTerm: string, filterLabel: string) => {
	const announceRef = useRef<HTMLDivElement>(null);
	const debounceTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
	const prevSearchTerm = useRef<string>("");
	const prevFilterLabel = useRef<string>(filterLabel);

	useEffect(() => {
		const hasSearchChanged = prevSearchTerm.current !== searchTerm;
		const hasFilterChanged = prevFilterLabel.current !== filterLabel;

		if (!hasSearchChanged && !hasFilterChanged) return;

		prevSearchTerm.current = searchTerm;
		prevFilterLabel.current = filterLabel;

		if (debounceTimer.current) {
			clearTimeout(debounceTimer.current);
		}

		debounceTimer.current = setTimeout(() => {
			if (announceRef.current) {
				announceRef.current.textContent = "";
				requestAnimationFrame(() => {
					if (announceRef.current) {
						const filterInfo = filterLabel && filterLabel !== "All" ? ` with filter "${filterLabel}"` : "";
						const searchInfo = searchTerm ? ` matching "${searchTerm}"` : "";
						announceRef.current.textContent =
							rowCount === 0
								? `No users found${searchInfo}${filterInfo}.`
								: `${rowCount} user${rowCount === 1 ? "" : "s"} found${searchInfo}${filterInfo}.`;
					}
				});
			}
		}, DEBOUNCE_DELAY);

		return () => {
			if (debounceTimer.current) {
				clearTimeout(debounceTimer.current);
			}
		};
	}, [rowCount, searchTerm, filterLabel]);

	return announceRef;
};

export default useAnnounceFilterResults;
